// @flow
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import styled from "styled-components";

import MinutesRemaining from "./MinutesRemaining";
import CodeChecker from "./CodeChecker";

const MainSection = styled.main`
	align-items: center;
	display: flex;
	flex-direction: column;
`;

type Props = {
	url?: string,
	minutes_remaining: number,
	onCorrectCode: Function,
};
type State = {};
export class BlockerPage extends Component<Props, State> {
	render() {
		var url;
		if (this.props.url) {
			let decoded_url = decodeURIComponent(this.props.url);
			let parsed_url = new URL(decoded_url);
			url = parsed_url.hostname;
		} else {
			url = "this page";
		}

		return (
			<MainSection>
				<MinutesRemaining minutes={this.props.minutes_remaining} />
				<CodeChecker
					heading={`Really need to open ${url}?`}
					onCorrectCode={this.props.onCorrectCode}
				/>
			</MainSection>
		);
	}
}

const mapStateToProps = (store_state, props) => {
	return {
		minutes_remaining: store_state.timer.minutes_remaining,
	};
};

const mapDispatchToProps = (dispatch, props) => {
	return bindActionCreators({}, dispatch);
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(BlockerPage);



// WEBPACK FOOTER //
// ../shared/components/BlockerPage.js